"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const test_1 = require("../test");
class TwingNodeExpressionTestNull extends test_1.TwingNodeExpressionTest {
    compile(compiler) {
        compiler
            .raw('(')
            .subcompile(this.getNode('node'))
            .raw(' === null)');
    }
}
exports.TwingNodeExpressionTestNull = TwingNodeExpressionTestNull;
